import { TFunction } from 'next-i18next';

const minValue = (t: TFunction, min: number, isInt = false) => (
  _rule: string,
  value: string | number,
  cb: Function
) => {
  if (!value) {
    cb(new Error(t('common:validation.required')));
    return;
  }

  const v = parseFloat(String(value));
  const isValid = isInt ? Number.isInteger(v) : !Number.isNaN(v);

  if (!isValid) {
    cb(new Error(isInt ? t('common:validation.integer') : t('common:validation.digit')));
  } else if (v < min) {
    cb(new Error(t('common:validation.min', { min })));
  } else {
    cb();
  }
};

export const getRules = (t: TFunction) => ({
  description: [
    {
      type: 'object',
      required: true,
      fields: {
        description: [
          { required: true, message: t('common:validation.required') },
          {
            min: 1,
            max: 45,
            message: t('common:validation.maxLength', { max: 45 }),
          },
        ],
      },
    },
  ],
  amount: [
    {
      type: 'object',
      required: true,
      fields: {
        count: { validator: minValue(t, 1, true) },
      },
    },
  ],
  weight: [
    {
      type: 'object',
      required: true,
      fields: {
        weight: { validator: minValue(t, 0.1) },
      },
    },
  ],
  price: [
    {
      type: 'object',
      required: true,
      fields: {
        price: { validator: minValue(t, 0.1) },
      },
    },
  ],
});
